import { AdvisorBubble, Column, FormUnit } from '@/components'
import { AssessmentStepKeys } from '@/enums'
import { useNextLoading, useOnNextClick } from '@/providers'
import { useTranslation } from 'react-i18next'
import { useSaveAssessmentStep } from '../helpers'
import { StepperTestimonial } from './StepperTestimonial'

export const CostOfElectronicsStep = () => {
  const { t } = useTranslation()
  const { save, isLoading } = useSaveAssessmentStep(
    AssessmentStepKeys.costOfElectronics,
  )

  useOnNextClick(save)

  useNextLoading(() => isLoading, [isLoading])

  return (
    <Column gap="24px">
      <FormUnit
        helperText={t('costOfElectronicsHelperText')}
        name="approximateCostOfElectroEquipment"
        placeholder={t('currencyInputPlaceholder')}
        unit="€"
      />
      <AdvisorBubble text={t('costOfElectronicsAdvisorHint')} />
    </Column>
  )
}

export const CostOfElectronicsStepTestimonial = () => (
  <StepperTestimonial stepKey="costOfElectronics" imageSrc="emily-headshot" />
)
